export const JOB_ROUTES = [
  {
    path: '/jobs',
    name: 'JobList',
    component: () => import('./views/JobList.vue'),
  },
  {
    path: '/jobs/pending',
    name: 'PendingJobs',
    component: () => import('./views/PendingJobs.vue'),
  },
  {
    path: '/jobs/view',
    name: 'ViewJobs',
    component: () => import('./views/ViewJobs.vue'),
  },
]

export const FIELD_JOB_ROUTES = [
  {
    path: 'jobs/view',
    name: 'FieldViewJobs',
    component: () => import('./views/ViewJobs.vue'),
  },
]
